import {throwError as observableThrowError, Observable, BehaviorSubject} from 'rxjs';

import {catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpBackend } from '@angular/common/http';
import {Router} from '@angular/router';
import {environment} from '@myenv/environment';

@Injectable()
export class OtaService {
  sideData = [
    {
      name: 'menu.CAMPAIGN',
      img: 'flag-checkered',
      route: '/ota'
    }, {
      name: 'menu.FILES',
      img: 'cube',
      route: '/ota/files'
    }
  ];


  d = new Date();
  offsetInMinutes = this.d.getTimezoneOffset() * -1;
  timeZone = `?dateFormat=${environment.isoDateTimeFormat}&offsetInMinutes=${this.offsetInMinutes}`;

  public apiv2Url = environment.apiV2Url;
  private httpClient: HttpClient;
  public type!: string;
  public customerId!: Number;

  constructor(private http: HttpClient, private router: Router, private handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  private messageSource = new BehaviorSubject(this.sideData);
  currentMessage = this.messageSource.asObservable();

  // this.productType = ;
  // // this.productType = currentUsr.productType;

  getAllOta(page: number): Observable<any> {
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/files?page=` + page).pipe(
      catchError(this.handleError));
  }

  getAllOtaFiles(data: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/ota/files/fileType/` + data).pipe(
      catchError(this.handleError));
  }

  getEcuCampaignFiles(data: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/files/fileType/` + data).pipe(
      catchError(this.handleError));
  }

  loadFiles(campaignId: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/${campaignId}/files`).pipe(
      catchError(this.handleError));
  }

  getCommands(campaignId: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/${campaignId}/commands`).pipe(
      catchError(this.handleError));
  }

  getFileDetails(fileId: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/ota/files/` + fileId).pipe(
      catchError(this.handleError));
  }

  getDeviceHistory(data: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/${data.campaignId}/device/${data.serialNumber}/history`).pipe(
      catchError(this.handleError));
  }

  getV2DeviceHistory(data: any, productType: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    return this.http.get(this.apiv2Url + `${productType}/${this.customerId}/v2/campaigns/${data.campaignId}/device/${data.serialNumber}/history`).pipe(
      catchError(this.handleError));
  }

  uploadXL(data: any, fileName: any, fileType: any, fileVersion: any, ecuGroup: any, ecuName: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      // 'Content-Type': 'multipart/form-data'
    });
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/files/fileType/${fileType}/upload?fileName=${fileName}`;
    if (fileVersion) tempUrl += `&fileVersion=${fileVersion}`;
    if (ecuGroup && ecuName) {
      tempUrl += `&ecuGroup=${ecuGroup}&ecuName=${ecuName}`;
    }
    return this.httpClient.post(tempUrl, data, {headers}).pipe(
      catchError(this.handleError));
  }

  uploadV2XL(data: any, fileName: any, fileType: any, fileVersion: any, ecuGroup: any, ecuName: any, productType: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      // 'Content-Type': 'multipart/form-data'
    });
    let tempUrl = this.apiv2Url + `${productType}/${this.customerId}/v2/campaigns/files/fileType/${fileType}/upload?fileName=${fileName}`;
    if (fileVersion) tempUrl += `&fileVersion=${fileVersion}`;
    if (ecuGroup && ecuName) {
      tempUrl += `&ecuGroup=${ecuGroup}&ecuName=${ecuName}`;
    }
    return this.httpClient.post(tempUrl, data, {headers}).pipe(
      catchError(this.handleError));
  }

  deleteOta(fileId: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.delete(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/ota/files/` + fileId).pipe(
      catchError(this.handleError));
  }

  deleteCampaign(campaignId: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.delete(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/` + campaignId).pipe(
      catchError(this.handleError));
  }

  deleteDevice(campaignId: string, serialNumber: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.delete(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/` + campaignId + '/device/' + serialNumber + '/cancel').pipe(
      catchError(this.handleError));
  }

  associateDevice(listnerType: any, otaType: any, fileId: string, data: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.put(this.apiv2Url + `${this.type}/${this.customerId}/v2/ota/files/` + fileId, data).pipe(
      catchError(this.handleError));
  }

  editUsersVisibility(fileId: string, userIds: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      // 'Content-Type': 'multipart/form-data'
    });
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/ota/files/` + fileId + '/visibility';
    if (userIds.length) {
      tempUrl += '?userIds=' + userIds;
    }
    return this.http.put(tempUrl, headers).pipe(
      // return this.http.put(this.apiv2Url +'ota/files/'+fileId+'/visibility?userIds='+ userIds, headers)
      catchError(this.handleError));
  }

  uploadConfigXL(data: any, folderName: any): Observable<any> {
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      // 'Content-Type': 'multipart/form-data'
    });
    return this.httpClient.post(this.apiv2Url + 'configurations?folderName=' + folderName, data, {headers}).pipe(
      catchError(this.handleError));
  }

  deleteConfig(folderName: any): Observable<any> {
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.delete(this.apiv2Url + 'configurations/folder/' + folderName).pipe(
      catchError(this.handleError));
  }

  getOta(): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
    });

    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/ota`, {headers}).pipe(
      catchError(this.handleError));
  }

  getAllCampaign(page: number): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
    });

    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns?page=` + page, {headers}).pipe(
      catchError(this.handleError));
  }

  onSearchOta(value: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(`${this.apiv2Url}${this.type}/${this.customerId}/v2/ota?serialNumber=${value}`).pipe(
      catchError(this.handleError));
  }

  addCampaign(data: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    return this.httpClient.post(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns`, data, {headers}).pipe(
      catchError(this.handleError));
  }

  addMoreDevices(campaignId: string, typeId: string, data: any, overRide?: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    let tempURL = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/${campaignId}/devices`;
    if (overRide) {
      tempURL += '?action=1';
    }
    return this.http.put(tempURL, data, {headers}).pipe(
      catchError(this.handleError));
  }

  uploadMoreDevices(campaignId: string, typeId: string, data: any, action: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    return this.httpClient.put(
      this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/devices/upload/campaignId/${campaignId}?action=${action}`, data, {headers}
    ).pipe(catchError(this.handleError));
  }

  getDeviceswithStatus(campaignId: string, status: any, page: number, serialNumber?: string, errorCode?: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    if (status === 'progress' && errorCode !== 'all') {
      status = errorCode;
      errorCode = null;
    }
    let tempURL = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/${campaignId}/device/status/${status}?page=${page}`;
    if (serialNumber) tempURL += '&serialNumber=' + serialNumber;
    if (errorCode && !['all', 'PROGRESS', 'DOWNLOAD_SUCCESS'].includes(errorCode)) tempURL += '&errorCode=' + errorCode;
    return this.http.get(tempURL).pipe(catchError(this.handleError));
  }

  getallDeviceswithStatus(campaignId: string, page: number, serialNumber?: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let tempURL = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/` + campaignId + '/devices?page=' + page;
    if (serialNumber) {
      tempURL += '&serialNumbers=' + serialNumber;
    }
    return this.http.get(tempURL).pipe(
      catchError(this.handleError));
  }

  getCampaignCount(): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/count`).pipe(
      catchError(this.handleError));
  }

  getFilesCount(): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/ota/files/count`).pipe(
      catchError(this.handleError));
  }

  getCounts(campaignId: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/` + campaignId).pipe(
      catchError(this.handleError));
  }

  uploadCampaign(data: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    return this.httpClient.post(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/upload`, data, {headers}).pipe(
      catchError(this.handleError));
  }

  getAllDevices(page: number): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + 'devices?limit=3000').pipe(
      catchError(this.handleError));
  }

  onSearchCampaignDevice(campaignId: string, value: any, status: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let tempURL = `${this.apiv2Url}${this.type}/${this.customerId}/v2/campaigns/${campaignId}/device?serialNumber=${value}`;
    if (status) {
      tempURL += '&status=' + status;
    }
    return this.http.get(tempURL).pipe(
      catchError(this.handleError));
  }

  onSearchFile(key: string, value: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(`${this.apiv2Url}${this.type}/${this.customerId}/v2/campaigns/files/search/${key}?value=${value}`).pipe(
      catchError(this.handleError));
  }

  handleError(error: any | any) {
    return observableThrowError(error.error || error || 'Server error');
  }

  downloadFileCSV(searchData?: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/ota/files/download` + this.timeZone;
    if (searchData.vehicleTypeVal) {
      tempUrl += '&key=' + searchData.campaign + '&value=' + searchData.vehicleTypeVal;
    }
    return this.http.get(tempUrl, {responseType: 'arraybuffer', observe: 'response'}).pipe(
      catchError(this.handleError));
  }

  downloadCampaignCSV(searchData: any, label?: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/download` + this.timeZone;
    // if (searchData.vehicleTypeVal || deviceStatusKey) {
    if (label) {
      tempUrl += '&label=' + label;
    }
    if (searchData.vehicleTypeVal) {
      tempUrl += '&key=' + searchData.campaign + '&value=' + searchData.vehicleTypeVal;
    }
    // if (deviceStatusKey && searchData.vehicleTypeVal) {
    //   tempUrl += '?key=' + searchData.campaign + '&value=' + searchData.vehicleTypeVal + '&status=' + deviceStatusKey;
    // }
    // }
    return this.http.get(tempUrl, {responseType: 'arraybuffer', observe: 'response'})
      .pipe(catchError(this.handleError));
  }

  downloadSelectedDeviceCSV(serialNumbers: any, label?: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/device/latest-status/download` + this.timeZone;
    // if (searchData.vehicleTypeVal || deviceStatusKey) {
    //   if (deviceStatusKey) {
    //     tempUrl += '&status=' + deviceStatusKey;
    //   }
    //   if (searchData.vehicleTypeVal) {
    //     tempUrl += '&key=' + searchData.campaign + '&value=' + searchData.vehicleTypeVal;
    //   }
    if (serialNumbers) tempUrl += '&serialNumbers=' + serialNumbers;
    if (label) tempUrl += `&label=${label}`;
    // }
    return this.http.get(tempUrl, {responseType: 'arraybuffer', observe: 'response'})
      .pipe(catchError(this.handleError));
  }

  downloadOtaFilesCSV(searchData: any, deviceStatusKey?: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/ota/files/download` + this.timeZone;
    // if (searchData.vehicleTypeVal || deviceStatusKey) {
    if (deviceStatusKey) {
      tempUrl += '&status=' + deviceStatusKey;
    }
    if (searchData.vehicleTypeVal) {
      tempUrl += '&key=' + searchData.campaign + '&value=' + searchData.vehicleTypeVal;
    }
    // if (deviceStatusKey && searchData.vehicleTypeVal) {
    //   tempUrl += '?key=' + searchData.campaign + '&value=' + searchData.vehicleTypeVal + '&status=' + deviceStatusKey;
    // }
    // }
    return this.http.get(tempUrl, {responseType: 'arraybuffer', observe: 'response'})
      .pipe(catchError(this.handleError));
  }

  downloadCampaignDeviceCSV(campaignId: string, status?: any, searchValue?: string, errorCode?: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    if (status === 'PROGRESS' && errorCode !== 'all') {
      status = errorCode;
      errorCode = null;
    }
    let tempUrl = `${this.apiv2Url}${this.type}/${this.customerId}/v2/campaigns/${campaignId}/device/download` + this.timeZone;
    if (status) tempUrl += '&status=' + status;
    if (searchValue) tempUrl += '&serialNumber=' + searchValue;
    if (errorCode && !['all', 'PROGRESS', 'DOWNLOAD_SUCCESS'].includes(errorCode)) tempUrl += '&errorCode=' + errorCode;
    return this.http.get(tempUrl, {responseType: 'arraybuffer', observe: 'response'}).pipe(
      catchError(this.handleError));
  }

  onSearchCampaign(key: string, value: any, label?: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    let tempUrl = `${this.apiv2Url}${this.type}/${this.customerId}/v2/campaigns/search`;
    if (key && value) {
      const char = tempUrl.includes('?') ? '&' : '?';
      tempUrl += `${char}key=${key}&value=${value}`;
    }
    if (label) {
      const char = tempUrl.includes('?') ? '&' : '?';
      tempUrl += `${char}key=label&value=${label}`;
    }
    return this.httpClient.get(tempUrl, {headers}).pipe(catchError(this.handleError));
  }

  retryDeviceCampaign(campaignId: string, serialNumber: string) {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    return this.httpClient.put(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/campaignId/${campaignId}/serialNumber/${serialNumber}/retry`, '', {headers})
      .pipe(catchError(this.handleError));
  }

  getRetryDeviceCount(campaignId: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    return this.httpClient.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/${campaignId}/devices/status/count/retry/all`, {headers})
    .pipe(catchError(this.handleError));
  }

  retryAllDeviceCampaign(campaignId: string, status: any, timeDiff: any) {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    let tempURL = `${this.type}/${this.customerId}/v2/campaigns/${campaignId}/devices/retry/all?override=true`;
    if (['PROGRESS', 'CANCELLED', 'FAILED', 'DOWNLOAD_SUCCESS', 'SUCCESS', 'INSTALL_SUCCESS', 'INSTALL_FAILED', 'SCHEDULED'].includes(status)) tempURL += `&status=${status}`;
    else tempURL += `&status=FAILED&errorCode=${status}`;
    if (timeDiff) tempURL += `&timeDifference=${timeDiff}`;
    return this.httpClient.post(this.apiv2Url + tempURL, {}, {headers})
    .pipe(catchError(this.handleError));
  }

  cancelAndRetryDevice(campaignId: string, serialNumber: string) {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase;
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    return this.httpClient.put(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/campaignId/${campaignId}/serialNumber/${serialNumber}/retry`, '', {headers})
      .pipe(catchError(this.handleError));
  }

  triggerFlashDevice(campaignId: string, serialNumber: string) {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    return this.httpClient.put(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/campaignId/${campaignId}/serialNumber/${serialNumber}/flashEcu`, '', {headers})
      .pipe(catchError(this.handleError));
  }

  getEcuGroups(): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/ecu/groups`).pipe(
      catchError(this.handleError));
  }

  getEcuNames(ecuGroup: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/ecu/names?ecuGroup=${ecuGroup}`).pipe(
      catchError(this.handleError));
  }

  getCampaignUploadHistory(page: number, campaignId: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/${campaignId}/log?page=${page}&limit=100`).pipe(
      catchError(this.handleError));
  }

  downloadLogDetailsCSV(logId: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(
      this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/log/${logId}/download`,
      {responseType: 'arraybuffer', observe: 'response'}
    ).pipe(catchError(this.handleError));
  }

  // Campaign dashboard API
  getAllCampaignCount(customerId?: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/type/count`;
    if (customerId) {
      tempUrl += `?customerId=${customerId}`;
    }
    return this.http.get(tempUrl)
    .pipe(catchError(this.handleError));
  }

  getHistoricalCampaignCount(months?: any, customerId?: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/type/historical/count`;
    if (months) {
      const char = tempUrl.includes('?') ? '&' : '?';
      tempUrl += `${char}count=${months}`;
    }
    if (customerId) {
      const char = tempUrl.includes('?') ? '&' : '?';
      tempUrl += `${char}customerId=${customerId}`;
    }
    return this.http.get(tempUrl).pipe(catchError(this.handleError));
  }

  getAllCampaignDeviceCount(label: any, type: string, customerId?: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/device/category/count`;
    if (label) {
      const char = tempUrl.includes('?') ? '&' : '?';
      tempUrl += `${char}label=${label}`;
    }
    if (type) {
      const char = tempUrl.includes('?') ? '&' : '?';
      tempUrl += `${char}type=${type}`;
    }
    if (customerId) {
      const char = tempUrl.includes('?') ? '&' : '?';
      tempUrl += `${char}customerId=${customerId}`;
    }
    return this.http.get(tempUrl).pipe(catchError(this.handleError));
  }

  getAllCampaignFilteredDevices(label: any, type: string, status: any, customerId?: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/device/category?status=${status}&page=0&limit=100`;
    if (label) {
      tempUrl += `&label=${label}`;
    }
    if (type) {
      tempUrl += `&type=${type}`;
    }
    if (customerId) {
      tempUrl += `&customerId=${customerId}`;
    }
    return this.http.get(tempUrl).pipe(catchError(this.handleError));
  }

  downloadCampaignFilteredDevicesCSV(label: any, type: string, status: any, customerId?: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/device/category/download${this.timeZone}&status=${status}`;
    if (label) {
      tempUrl += `&label=${label}`;
    }
    if (type) {
      tempUrl += `&type=${type}`;
    }
    if (customerId) {
      tempUrl += `&customerId=${customerId}`;
    }
    return this.http.get(tempUrl, {responseType: 'arraybuffer', observe: 'response'})
    .pipe(catchError(this.handleError));
  }

  getAllLabels(customerId?: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/ota/labels`;
    if (customerId) {
      tempUrl += `?customerId=${customerId}`;
    }
    return this.http.get(tempUrl).pipe(catchError(this.handleError));
  }

  createLabel(label: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    return this.httpClient.post(this.apiv2Url + `${this.type}/${this.customerId}/v2/ota/labels/${label}`, {}, {headers})
    .pipe(catchError(this.handleError));
  }

  updateCampaign(campaignId: string, description?: any, label?: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/${campaignId}`;
    if (description) {
      const char = tempUrl.includes('?') ? '&' : '?';
      tempUrl += `${char}description=${description}`;
    }
    if (label) {
      const char = tempUrl.includes('?') ? '&' : '?';
      tempUrl += `${char}label=${label}`;
    }
    return this.http.put(tempUrl, headers).pipe(catchError(this.handleError));
  }

  getSubFilters(campaignId: string, status: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    return this.http.get(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/${campaignId}/status/${status}/category/count`)
    .pipe(catchError(this.handleError));
  }

  editCampaign(campaignID: any,data: any): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    return this.httpClient.put(this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/`+campaignID, data, { headers }).pipe(
      catchError(this.handleError));
  }

  editfile(data: any, fileId: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
    });
    let tempUrl = this.apiv2Url + `${this.type}/${this.customerId}/v2/campaigns/ota/files/${fileId}`;
    return this.httpClient.put(tempUrl, {description:data}, { headers }).pipe(
      catchError(this.handleError));
  }
}
